export default __webpack_public_path__ + "static/benefitImage2-85c8338d12e9653d90f49a5e76397ac7.webp";